import { useEffect, useState } from 'react';
import { Button, Tooltip } from 'flowbite-react';

const SCROLL_THRESHOLD = 120;

const ArrowUpIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M5 11.5 12 4l7 7.5" />
    <path d="M12 5v14" />
  </svg>
);

function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleScroll = () => {
      setIsVisible(window.scrollY > SCROLL_THRESHOLD);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClick = () => {
    if (typeof window === 'undefined') return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Tooltip content="Scroll to top" placement="left" style="light">
        <Button
          aria-label="Scroll to top"
          color="light"
          size="xs"
          onClick={handleClick}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white/90 text-slate-700 shadow-md transition hover:bg-white hover:shadow-lg focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-slate-700 dark:bg-slate-800/90 dark:text-slate-100 dark:hover:bg-slate-800 !p-2"
        >
          <ArrowUpIcon className="h-4 w-4" />
        </Button>
      </Tooltip>
    </div>
  );
}

export default ScrollToTopButton;
